


















import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import AcceptPendingOffersTrigger from './AcceptPendingOffersTrigger.coffee'

settings =
  name: 'AcceptPendingOffersTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton }
    mixins: [AcceptPendingOffersTrigger.trigger()]

    computed:
      modalConfig: -> @modal.config || {}
      offerCount: ->
        @modalConfig.item.ctx["stats"]["offer"]["pending_count"] if @modalConfig.item

export default VueOptions.vue settings
